var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ac-container" },
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "", row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { grow: "" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query"
                }
              ],
              staticClass: "with-icon icon-search sm text-lowercase",
              attrs: {
                disabled: this.selected,
                id: "search",
                type: "text",
                placeholder: this.label,
                autocomplete: "off"
              },
              domProps: { value: _vm.query },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.search(_vm.query)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.query = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              this.selected
                ? _c(
                    "v-btn",
                    {
                      staticClass: "primary text-lowercase",
                      attrs: { loading: _vm.preloader, small: "" },
                      on: {
                        click: function($event) {
                          return _vm.clear()
                        }
                      }
                    },
                    [_c("span", [_vm._v("limpar")])]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "primary text-lowercase",
                      attrs: { loading: _vm.preloader, small: "" },
                      on: {
                        click: function($event) {
                          return _vm.search(_vm.query)
                        },
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search(_vm.query)
                        }
                      }
                    },
                    [_c("span", [_vm._v("buscar")])]
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { attrs: { column: "" } }, [
        _vm.results.length
          ? _c(
              "ul",
              _vm._l(_vm.results, function(result, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.select(result)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.getLabel(result)) + "\n      "
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29aa0123", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29aa0123","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Autocomplete.vue
// module id = null
// module chunks = 